(function($) {
	$('.hamburger').on('click', function(e) {
    e.preventDefault();

    if( $('body').hasClass('navigationpanel-open') ) {
      window.panel_close('NavigationPanel');
    } else {
      window.panel_open('NavigationPanel')
    }
  });
})(jQuery);